// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RejectionBanner_rejectionBanner__LD541 {
  background: linear-gradient(135deg, #fff5f5 0%, #fee2e2 100%);
  border: 1.5px solid #f87171;
  border-left: 6px solid #dc2626;
  border-radius: 18px 18px 12px 12px;
  padding: 1rem 1.25rem;
  margin: 0 auto 1.25rem auto;
  max-width: 960px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.08);
  animation: RejectionBanner_slideDown__Nvj-i 0.3s ease;
  font-family: 'CircularXXWeb-Book', -apple-system, BlinkMacSystemFont, sans-serif;
}

.RejectionBanner_iconWrapper__rb2bY {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #fee2e2;
  color: #dc2626;
  display: flex;
  align-items: center;
  justify-content: center;
}

.RejectionBanner_contentWrapper__YQu\\+M {
  flex: 1 1;
}

.RejectionBanner_bannerTitle__EiYec {
  font-size: 1rem;
  font-weight: 700;
  color: #991b1b;
  margin: 0 0 0.35rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.RejectionBanner_statusTag__1Drnh {
  background: #dc2626;
  color: #ffffff;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 0.15rem 0.45rem;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.RejectionBanner_reasonBox__fR-61 {
  background: rgba(255, 255, 255, 0.85);
  border: 1px solid #fca5a5;
  border-radius: 8px;
  padding: 0.65rem 0.85rem;
  margin: 0.5rem 0;
  font-size: 0.92rem;
  color: #7f1d1d;
  line-height: 1.45;
}

.RejectionBanner_reasonLabel__v7Omy {
  font-weight: 700;
  margin-right: 0.35rem;
  color: #991b1b;
}

.RejectionBanner_guidanceText__7Mi0r {
  font-size: 0.82rem;
  color: #b91c1c;
  margin: 0.35rem 0 0 0;
  font-style: italic;
}

@keyframes RejectionBanner_slideDown__Nvj-i {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/RejectionBanner.module.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8BAA8B;EAC9B,kCAAkC;EAClC,qBAAqB;EACrB,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,8CAA8C;EAC9C,qDAA8B;EAC9B,gFAAgF;AAClF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".rejectionBanner {\n  background: linear-gradient(135deg, #fff5f5 0%, #fee2e2 100%);\n  border: 1.5px solid #f87171;\n  border-left: 6px solid #dc2626;\n  border-radius: 18px 18px 12px 12px;\n  padding: 1rem 1.25rem;\n  margin: 0 auto 1.25rem auto;\n  max-width: 960px;\n  width: 100%;\n  box-sizing: border-box;\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.08);\n  animation: slideDown 0.3s ease;\n  font-family: 'CircularXXWeb-Book', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.iconWrapper {\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #fee2e2;\n  color: #dc2626;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.contentWrapper {\n  flex: 1;\n}\n\n.bannerTitle {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #991b1b;\n  margin: 0 0 0.35rem 0;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.statusTag {\n  background: #dc2626;\n  color: #ffffff;\n  font-size: 0.7rem;\n  font-weight: 700;\n  padding: 0.15rem 0.45rem;\n  border-radius: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.reasonBox {\n  background: rgba(255, 255, 255, 0.85);\n  border: 1px solid #fca5a5;\n  border-radius: 8px;\n  padding: 0.65rem 0.85rem;\n  margin: 0.5rem 0;\n  font-size: 0.92rem;\n  color: #7f1d1d;\n  line-height: 1.45;\n}\n\n.reasonLabel {\n  font-weight: 700;\n  margin-right: 0.35rem;\n  color: #991b1b;\n}\n\n.guidanceText {\n  font-size: 0.82rem;\n  color: #b91c1c;\n  margin: 0.35rem 0 0 0;\n  font-style: italic;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rejectionBanner": `RejectionBanner_rejectionBanner__LD541`,
	"slideDown": `RejectionBanner_slideDown__Nvj-i`,
	"iconWrapper": `RejectionBanner_iconWrapper__rb2bY`,
	"contentWrapper": `RejectionBanner_contentWrapper__YQu+M`,
	"bannerTitle": `RejectionBanner_bannerTitle__EiYec`,
	"statusTag": `RejectionBanner_statusTag__1Drnh`,
	"reasonBox": `RejectionBanner_reasonBox__fR-61`,
	"reasonLabel": `RejectionBanner_reasonLabel__v7Omy`,
	"guidanceText": `RejectionBanner_guidanceText__7Mi0r`
};
export default ___CSS_LOADER_EXPORT___;
